import { FC, useEffect } from 'react';
import { useToast } from '@/contexts/ToastContext';

/**
 * Mostra toast quando o backend devolve 403 `seop_feature_not_enabled`.
 *
 * O `SeopRoute` cobre a navegação. Este host cobre o caso que ele não alcança:
 * o admin desliga a flag **com a tela aberta**. Sem isto, a próxima chamada cai
 * no `console.error('Acesso proibido')` do interceptor e o usuário vê uma tela
 * que simplesmente para de responder.
 *
 * Fica montado uma vez no `AppLayout` (dentro do `ToastProvider`), então vale
 * para o módulo inteiro — o `SeopLayout` cuida só das abas.
 */
const SeopFeatureBlockedHost: FC = () => {
  const { showToast } = useToast();

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<{ message?: string }>).detail;
      showToast(
        detail?.message ||
          'Acesso ao Balanceamento de Linha foi desligado pra você. Fale com seu admin.',
        'warning',
      );
    };
    window.addEventListener('seop-feature-blocked', handler);
    return () => window.removeEventListener('seop-feature-blocked', handler);
  }, [showToast]);

  return null;
};

export default SeopFeatureBlockedHost;
